import { tickerItems } from "@/mocks/nav";

const hotTags = ["番位风波", "音乐节抢票", "综艺剪辑", "短剧出海", "品牌联名", "颁奖礼"];

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="top" className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20warm%20crimson%20and%20amber%20editorial%20background%20with%20soft%20film%20grain%2C%20dramatic%20spotlight%20beams%2C%20dark%20vignette%20edges%2C%20cinematic%20entertainment%20magazine%20aesthetic%2C%20no%20text&width=1600&height=900&seq=gua-hero-01&orientation=landscape"
        alt="5.1吃瓜 娱乐事件盘点专题视觉背景"
        title="5.1吃瓜 娱乐事件盘点"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/40 to-transparent" />

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-8">
        <div className="max-w-3xl animate-rise">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 backdrop-blur-sm text-xs md:text-sm text-background-50 mb-5">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-hot-dot" />
            今日焦点 · 持续更新中
          </span>

          <h1 className="font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-[1.15] mb-5">
            5.1吃瓜
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-bold text-accent-300">
              一次看懂娱乐大瓜的来龙去脉
            </span>
          </h1>

          <p className="text-background-100/90 text-sm md:text-base leading-relaxed max-w-2xl mb-8">
            我们把近期受到关注的热门事件，按事件热度与时间线整理成可读的盘点合集。无论你是想系统补课的老瓜农，还是刚入坑的新吃瓜群众，都能在这里快速抓住焦点，吃瓜不迷路。
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-8">
            <a
              href="#focus"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("focus");
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line" />
              看今日焦点盘点
            </a>
            <a
              href="#timeline"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("timeline");
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-route-line" />
              按时间线补课
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-100/70 mr-1">正在升温：</span>
            {hotTags.map((tag) => (
              <a
                key={tag}
                href="#events"
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo("events");
                }}
                className="px-3 py-1 rounded-full text-xs text-background-50/90 bg-background-50/10 border border-background-50/20 hover:bg-accent-500 hover:text-foreground-950 hover:border-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                #{tag}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 z-10 bg-gradient-to-r from-primary-700/90 to-primary-600/90 backdrop-blur-sm">
        <div className="flex items-center">
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 px-4 md:px-8 h-9 text-xs text-background-50 font-medium bg-primary-800/70">
            <i className="ri-flashlight-fill text-accent-400" />
            滚动快讯
          </span>
          <div className="overflow-hidden flex-1 py-2">
            <div className="flex w-max animate-marquee">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="text-xs text-background-50/95 px-6 whitespace-nowrap"
                >
                  · {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}